import React from 'react';
import { Link } from 'react-router-dom';
import { imgUrl } from '../lib/utils';

export const GameCard = ({ product }) => {
  const linkTo = `/product/${product.slug}`;

  return (
    <Link
      to={linkTo}
      className="game-card group relative overflow-hidden rounded-lg transition-all duration-300"
      style={{
        background: 'hsl(var(--card))',
        border: '1px solid hsl(var(--border))',
      }}
      data-testid={`game-card-${product.slug}`}
    >
      {/* Image */}
      <div className="product-image relative">
        <img
          src={imgUrl(product.image)}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {/* Hover overlay — stone + gold tint */}
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ background: 'linear-gradient(to top, hsl(var(--background) / 0.95) 0%, hsl(var(--background) / 0.3) 50%, transparent 100%)' }}
        />
        {/* Lotus corner accents on hover */}
        <span
          className="absolute top-2 left-2 text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm"
        >✦</span>
        <span
          className="absolute bottom-2 right-2 text-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm"
        >✦</span>
        {/* Gold top edge bar on hover */}
        <div
          className="absolute top-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ background: 'linear-gradient(to right, transparent, hsl(var(--primary) / 0.7), transparent)' }}
        />
      </div>

      {/* Content */}
      <div className="p-3">
        <h3
          className="font-bold text-white text-sm md:text-base truncate group-hover:text-primary transition-colors"
          style={{ fontFamily: "'Cinzel', serif" }}
        >
          {product.name}
        </h3>
        {product.source === 'digiflazz' ? (
          <p className="text-xs text-primary/80 mt-0.5" style={{ fontFamily: "'Space Mono', monospace" }}>
            {product.itemCount} item · Mulai Rp {product.startPrice?.toLocaleString('id-ID')}
          </p>
        ) : (
          <p className="text-xs text-muted-foreground capitalize mt-0.5" style={{ fontFamily: "'Lora', serif" }}>
            {product.category}
          </p>
        )}
      </div>
    </Link>
  );
};

export const GameCardSkeleton = () => {
  return (
    <div className="rounded-lg overflow-hidden" style={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }}>
      <div className="aspect-square skeleton" />
      <div className="p-3 space-y-2">
        <div className="h-4 skeleton rounded w-3/4" />
        <div className="h-3 skeleton rounded w-1/2" />
      </div>
    </div>
  );
};
